export const SET_FETCHING_VIDEO_HEADER = 'SET_FETCHING_VIDEO_HEADER';
export const SET_VIDEO_DATA = 'SET_VIDEO_DATA';
export const SET_VIDEO_IMAGES = 'SET_VIDEO_IMAGES';
